<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-list-item @mouseover="showButton = true"
               @mouseleave="showButton = false"
               :style="{'background-color': color}">
    <v-list-item-content>

      <v-list-item-title>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon
            :color="chooseStateColor(pendingTask.state)"
            class="mr-2"
            size="small"
            v-on="on">
            mdi-brightness-1
            </v-icon>
          </template>
          <span>
            {{ pendingTask.state === -1 ? $t('general.expiredTime') : (pendingTask.state === 0 ? $t('general.aboutToExpire') : $t('general.onTime')) }}
          </span>
        </v-tooltip>
        {{pendingTask.name}}
      </v-list-item-title>

      <v-list-item-subtitle>
        {{pendingTask.userName}}
      </v-list-item-subtitle>

      <v-list-item-subtitle>
        {{pendingTask.shortDate}} - {{pendingTask.time}}
      </v-list-item-subtitle>
    </v-list-item-content>

    <v-fade-transition>
      <v-list-item-action v-show="showButton">
        <v-tooltip bottom>
          <template v-slot:activator="{on}">
            <v-btn icon
                   :loading="loading"
                   v-on="on"
                   @click="showUser(pendingTask)">
              <v-icon color="kbDarkBlue">
                remove_red_eye
              </v-icon>
            </v-btn>
          </template>
          <span>Ver Detalle</span>
        </v-tooltip>
      </v-list-item-action>
    </v-fade-transition>
  </v-list-item>
</template>

<script>
export default {
  data () {
    return {
      color: 'white',
      loading: false,
      showButton: false
    }
  },
  methods: {
    showUser (task) {
      this.$emit('showUser', task)
    },
    chooseStateColor (task) {
      switch (task) {
        case -1:
          return 'error'
        case 0:
          return 'warning'
        case 1:
          return 'success'
      }
    }
  },
  props: ['pendingTask']
}
</script>
